/* ============================================================
   AIMER VIVRE — SHOPIFY THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── HERO SLIDESHOW ──────────────────────────────────────────
  const slideshows = document.querySelectorAll('.hero-slideshow');
  slideshows.forEach(function(ss) {
    const track  = ss.querySelector('.hero-slides');
    const slides = ss.querySelectorAll('.hero-slide');
    const dots   = ss.querySelectorAll('.hero-dot');
    let current  = 0;
    let timer;

    if (!track || slides.length < 2) return;

    function go(n) {
      current = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }
    function startAuto() { timer = setInterval(next, 5000); }
    function stopAuto()  { clearInterval(timer); }

    ss.querySelector('.hero-arrow.next')?.addEventListener('click', function() { stopAuto(); next(); startAuto(); });
    ss.querySelector('.hero-arrow.prev')?.addEventListener('click', function() { stopAuto(); prev(); startAuto(); });
    dots.forEach(function(d, i) {
      d.addEventListener('click', function() { stopAuto(); go(i); startAuto(); });
    });

    startAuto();
  });

  // ── MOBILE NAV ──────────────────────────────────────────────
  const hamburger  = document.querySelector('.nav-hamburger');
  const mobileNav  = document.querySelector('.mobile-nav');
  const mobileClose= document.querySelector('.mobile-nav-close');

  hamburger?.addEventListener('click', function() {
    mobileNav?.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  mobileClose?.addEventListener('click', closeMobile);
  mobileNav?.addEventListener('click', function(e) {
    if (e.target === mobileNav) closeMobile();
  });
  function closeMobile() {
    mobileNav?.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ── PRODUCT IMAGE SWAP (PDP) ─────────────────────────────────
  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const main = document.querySelector('.product-main-img');
      if (main) {
        main.src = this.dataset.src;
        document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  // ── VARIANT SELECTION ───────────────────────────────────────
  document.querySelectorAll('.variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('unavailable')) return;
      const group = this.closest('.variant-options');
      group?.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      updateVariantId();
    });
  });

  function updateVariantId() {
    const activeButtons = document.querySelectorAll('.variant-btn.active');
    const variantInput  = document.querySelector('input[name="id"]');
    // Simple single-option variant lookup — multi-option handled in section schema
    if (activeButtons.length === 1 && variantInput) {
      const variantId = activeButtons[0].dataset.variantId;
      if (variantId) variantInput.value = variantId;
    }
  }

  // ── ADD TO CART ─────────────────────────────────────────────
  const atcForm = document.querySelector('.atc-form');
  atcForm?.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn   = this.querySelector('.atc-btn');
    const data  = new FormData(this);

    btn.disabled   = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        showToast('Added to cart!');
        updateCartCount();
        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.disabled    = false;
          btn.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function() {
        btn.disabled    = false;
        btn.textContent = 'Add to Cart';
        showToast('Error — please try again.');
      });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.nav-cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
  }

  // ── TOAST NOTIFICATION ──────────────────────────────────────
  function showToast(msg) {
    let toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 3000);
  }

  // ── QUICK ADD ────────────────────────────────────────────────
  document.querySelectorAll('.quick-add-btn[data-variant-id]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      this.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', body: body })
        .then(function(r) { return r.json(); })
        .then(function() {
          showToast('Added to cart!');
          updateCartCount();
          btn.textContent = 'Added ✓';
          setTimeout(function() { btn.textContent = 'Quick Add'; }, 2000);
        })
        .catch(function() { btn.textContent = 'Quick Add'; });
    });
  });

  // ── EMAIL SUBSCRIBE ──────────────────────────────────────────
  document.querySelectorAll('.email-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const input = this.querySelector('input[type="email"]');
      const btn   = this.querySelector('button');
      if (!input?.value) return;
      btn.textContent = 'Subscribed!';
      btn.style.background = '#1a6e1a';
      input.value = '';
      setTimeout(function() {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
      }, 3000);
    });
  });

  // ── INIT CART COUNT ──────────────────────────────────────────
  updateCartCount();

});
